import { useNotify } from 'react-admin'
import {
  extractErrorMessage,
  ERROR_MESSAGES,
  ErrorResponse,
} from '../utils/couponErrorHandler'

/**
 * Hook personalizado para tratamento de erros
 * Centraliza a lógica de exibição de mensagens de erro
 */
export const useErrorHandler = () => {
  const notify = useNotify()

  const handleError = (
    error: ErrorResponse,
    defaultMessage = 'Erro inesperado',
    context?: string
  ) => {
    console.error(`${context ? `[${context}] ` : ''}Erro:`, error)

    const errorMessage = extractErrorMessage(error, defaultMessage)
    notify(errorMessage, 'error')
  }

  const handleSuccess = (message: string) => {
    notify(message, 'success')
  }

  const handleWarning = (message: string) => {
    notify(message, 'warning')
  }

  const handleInfo = (message: string) => {
    notify(message, 'info')
  }

  return {
    handleError,
    handleSuccess,
    handleWarning,
    handleInfo,
    ERROR_MESSAGES,
  }
}
